import React from "react";
import profil from "../../../assets/images/profil1.png";
import "./About.css";
import Navbar from "../Navbar/Navbar";
import { useTranslation } from "react-i18next";
import NeonHeading from "../NeonHeading/NeonHeading";




const About = ({ reff }) => {
  const { t } = useTranslation();
  return (
    <section
      ref={reff}
      id="about"
      className="py-5"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="container">
        <NeonHeading color="purple">
          {t('p.2')}
        </NeonHeading>

        <div className="row">
          <div className="col-12 col-lg-4">
            <img className="d-block mx-auto mb-4" src={profil} alt="profil" />
          </div>
          <div className="col-lg-8">
            <p className="text-font text-justify">
              {t('int.10')}
              <br />
              <br />
            </p>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
